export const sampleAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }